import { memo, useState } from "react";
import { GridActionsCellItem } from '@mui/x-data-grid-premium';
import Tooltip from '@mui/material/Tooltip';
import List from '@mui/material/List';
import type { Setup } from "features/setups/types";
import Icon from "ui/atoms/Icon";
import Delete from "./Delete";
import Edit from "./Edit";
import Clone from "./Clone";
import CreateGroup from "./CreateGroup/CreateGroup";
import CreateGroupDialog from "./CreateGroup/CreateGroupDialog";

const TableActions = (row: Setup<string>) => {
    const [isCreateGroupDialogOpen, setCreateGroupDialogOpen] = useState<boolean>(false);
    return (
        <>
            <Tooltip
                arrow
                placement="left"
                title={(
                    <List dense disablePadding>
                        <Edit
                            row={row}
                        />
                        <Clone
                            row={row}
                        />
                        <Delete
                            row={row}
                        />
                        <CreateGroup
                            row={row}
                            create={() => setCreateGroupDialogOpen(true)}
                        />
                    </List>
                )}
            >
                <GridActionsCellItem
                    label="More"
                    icon={(
                        <Icon name="MoreVert" />
                    )}
                />
            </Tooltip>

            <CreateGroupDialog
                row={row}
                open={isCreateGroupDialogOpen}
                onClose={() => setCreateGroupDialogOpen(false)}
            />
        </>
    );
};

export default memo(TableActions);
